import { render, staticRenderFns } from "./PrintedContainerCadastral.vue?vue&type=template&id=3c18530f&scoped=true"
import script from "./PrintedContainerCadastral.vue?vue&type=script&lang=js"
export * from "./PrintedContainerCadastral.vue?vue&type=script&lang=js"
import style0 from "./PrintedContainerCadastral.vue?vue&type=style&index=0&id=3c18530f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c18530f",
  null
  
)

export default component.exports